import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Space, Table, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import AdminSearchBarHeader from '../component/AdminSearchBarHeader';
import qs from 'qs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { useNavigate } from 'react-router-dom';
import routes from '../../../controller/Routes';
import { reverse } from 'named-urls';
import { deleteQuestionById, getQuestion } from '../../../controller/api/questionServices';
import { getAdminDetail } from '../../../controller/localStroageHandler';
import dayjs from 'dayjs';
import { getTechnology } from '../../../controller/api/globalServices';
import Highlighter from 'react-highlight-words';

const getRandomuserParams = (params) => ({
  results: params.pagination?.pageSize,
  page: params.pagination?.current,
  ...params,
});

const Questionnaire = () => {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [technologiesList, setTechnologyList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });
  let userDetail = getAdminDetail()
  useEffect(() => {
    getQuestions()
    getTechnology({ search: '', data: 'all' }).then(res => {
      let techList = res?.data?.result?.map((tech) => ({
        text: tech.name,
        value: tech._id,
      }));
      setTechnologyList(techList)
    }).catch(err => {
      console.log("err ===> ", err)
    })
  }, [])
  const getQuestions = async() => {
    setLoading(true)
    await getQuestion({ id: userDetail?.organization_id?._id }).then(res => {
      setData(res?.data?.questions)
      setLoading(false)
    }).catch(err => {
      console.log("err ===> ", err)
      setLoading(false)
    })
  }

   const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  const handleSearch = (
    selectedKeys,
    confirm,
    dataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={`${selectedKeys[0] || ''}`}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys , confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>         
          <Button 
            type="primary"
            onClick={() => handleSearch(selectedKeys , confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters)
              handleSearch([], confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownOpenChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Question',
      dataIndex: 'title',
      sorter: true,
      // defaultSortOrder: 'descend',
      sorter: (a, b) => {
        console.log("a ===> ", a)
        return a.title.localeCompare(b.title);
      },
       ...getColumnSearchProps('title'),
    },
    {
      title: 'Difficulty',
      dataIndex: 'difficulty',
      // defaultSortOrder: 'descend',
      sorter: true,
      sorter: (a, b) => {
        return a.difficulty.localeCompare(b.difficulty);
      },
      filterSearch: true,
      filters: [
        {
          text: 'Easy',
          value: 'easy',
        },
        {
          text: 'Medium',
          value: 'medium',
        },
        {
          text: 'Hard',
          value: 'hard',
        },
      ],
      onFilter: (value, record) => record.difficulty.toLowerCase() === value.toLowerCase(),
      render: (text) => (
        <span
          className={`${text == 'easy'
            ? 'text-success'
            : text == 'medium'
              ? 'text-warning'
              : 'text-danger'
            }`}
        >
          {text}
        </span>
      ),
      className: 'text-capitalize fw-medium',
    },
    {
      title: 'Technology Used',
      dataIndex: 'technology',
      filterSearch: true,
      filters: technologiesList,
       onFilter: (value, record) => {
    return record.technology?.some((tech) => tech._id === value);
  },
      render: (technology) => {
        return (
          <div className='d-flex gap-2 flex-wrap p-1'>
            {technology?.map((val, index) => {
              return (
                <span
                  key={index}
                  className='skill-bg-color text-muted rounded-1 d-flex gap-1'
                  style={{
                    fontSize: '14px',
                    padding: '0px 5px',
                    cursor: 'pointer',
                  }}
                >
                  {val?.name}
                </span>
              );
            })}
          </div>
        );
      },
    },
    {
      title: 'Section',
      dataIndex: 'section',
      // filters: sectionList,
      // defaultSortOrder: 'descend',
      sorter: true,
      sorter: (a, b) => {
        return a.section.localeCompare(b.difficulty);
      },
      filterSearch: true,
      filters: [
        {
          text: 'Analytical',
          value: 'analytical',
        },
        {
          text: 'Theory',
          value: 'theory',
        },
        {
          text: 'Coding',
          value: 'coding',
        },
      ],
      onFilter: (value, record) => record.section.toLowerCase() === value.toLowerCase(),
 
    },
      {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
    sorter: true,
    render: (value) => dayjs(value).format('DD MMM YYYY, hh:mm A'),
       sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    defaultSortOrder: 'descend', 
  },
  {
    title: 'Updated At',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    sorter: true,
    render: (value) => dayjs(value).format('DD MMM YYYY, hh:mm A'),
       sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
  },
    {
      title: (
        <div className='w-100 d-flex justify-content-end'>
          <Button
            className='rounded-5 fw-bold d-flex justify-content-center align-items-center fw-semibold btn-border-color text-color-custom custom-hover-btn'
            onClick={() => navigate(routes.admin.dashboard.questionnaire.add)}
          >
            Add +
          </Button>
        </div>
      ),
      dataIndex: '',
      fixed: 'right',
      width: 150,
      render: (record) => (
        <div className='d-flex gap-4 text-color-custom justify-content-end'>
          <FontAwesomeIcon
            icon={faPenToSquare}
            style={{ cursor: 'pointer' }}
            onClick={() =>
              navigate(
                reverse(routes.admin?.dashboard?.questionnaire?.edit, {
                  id: record?._id,
                })
              )
            }
          />{' '}
          <FontAwesomeIcon
            style={{ cursor: 'pointer' }}
            icon={faTrashCan}
            onClick={() => {
              deleteQuestionById({ id: userDetail?.organization_id?._id, quesId: record?._id }).then(res => {
                message.success("Question Deleted Successfully")
                getQuestions()
              }).catch(err => {
                message.error("Something went wrong")
              })
            }}
          />
        </div>
      ),
    },
  ];
  // const handleTableChange = (pagination, filters, sorter) => {
  //   setTableParams({
  //     pagination,
  //     filters,
  //     ...sorter,
  //   });

  //   // `dataSource` is useless since `pageSize` changed
  //   if (pagination.pageSize !== tableParams.pagination?.pageSize) {
  //     setData([]);
  //   }
  // };

  return (
    <div className='w-100 h-100 p-4 bg-light'>
      <AdminSearchBarHeader search={search} setSearch={setSearch} />
      <Row align={'middle'} className='mt-4 mb-4'>
        <Col span={24} className='fs-6 fw-semibold'>
          Screening Question
        </Col>
      </Row>
      <Table
        className='table-container'
        scroll={{
          y: 450,
          x: 1200,
        }}
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={data}
        // pagination={{
        //   ...tableParams.pagination,
        //   showSizeChanger: true,
        //   total: total,
        //   showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
        // }}
        loading={loading}
      // onChange={handleTableChange}
      />
    </div>
  );
};

export default Questionnaire;
